module.exports = __webpack_public_path__ + "static/media/11.7526084e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/11.jpg
// module id = 581
// module chunks = 0